<div
  class="dynamic-filter"
  *ngIf="vertical() && !isMobile"
  [ngClass]="vertical() ? 'flex flex-col h-full' : 'hidden'"
  [style.background]="getBackgroundColor()"
  [style.border]="getBorderStyle()"
  [style.borderRadius]="'8px'"
>

  <ui-label [tag]="ELabelType.SUBTITLE" [type]="EAlert.INFO">Filtros</ui-label>

  <ui-dynamic-form (valueChange)="applyFilters($event)" [withBorder]="false" [finalSubmit]="'Buscar'" [useSteps]="false" [inList]="true" [fields]="fields()"></ui-dynamic-form>

</div>

<button *ngIf="shouldShowButton" (click)="openPopup()" class="filter-toggle-btn flex align-center">
  <ui-label [tag]="ELabelType.PARAGRAPH" [type]="EAlert.INFO">Filtros</ui-label> <ui-icon [icon]="EIcon.Filter" [fill]="true" [color]="EAlert.INFO" [size]="EComponentSize.Medium"></ui-icon>
</button>

<div *ngIf="isPopupOpen" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
  <div
    class="dynamic-filter bg-gray-900 text-white p-8 w-full h-full max-w-full max-h-full fixed inset-0 flex flex-col justify-center items-center space-y-4 rounded-lg shadow-lg animate-popup"
    [style.border]="getBorderStyle()"
  >
    <button
      class="absolute top-4 right-4 p-3 transition-transform duration-200 hover:scale-110"
      (click)="closeFilterPopup()"
    >
      <ui-icon [icon]="EIcon.Close" [fill]="false" [color]="EAlert.INFO" [size]="EComponentSize.Large"></ui-icon>
    </button>

    <ui-label [tag]="ELabelType.SUBTITLE" [type]="EAlert.INFO">Filtros</ui-label>

    <div class="flex flex-col space-y-4 w-11/12 max-w-3xl overflow-auto p-4 bg-gray-800 rounded-lg">
      <ui-dynamic-form (valueChange)="applyFilters($event)" [withBorder]="false" [finalSubmit]="'Buscar'" [useSteps]="false" [inList]="true" [fields]="fields()"></ui-dynamic-form>
    </div>

  </div>
</div>

